import { IconArrowSquareLeft, IconArrowSquareRight } from '@/features/icons';
import LazyImage from '@/features/image/lazy-image';
import { Modal } from '@/features/modal';
import { cn } from '@/utils/cn';
import { DetailModalDirection, IranianWomenItemViewModel } from '../../types';
interface Props {
  details: IranianWomenItemViewModel | null;
  direction: DetailModalDirection;
  handleCloseDetailsModal: () => void;
  handleNavigateDetailsModal: (type: DetailModalDirection) => void;
}
const WomanDetailModal = ({
  details,
  direction,
  handleCloseDetailsModal,
  handleNavigateDetailsModal
}: Props) => {
  if (!details) return null;
  return <Modal title='' isOpen={!!details} handleClose={handleCloseDetailsModal} className='z-20 h-full overflow-hidden rounded-none p-0 [&>div:first-child]:absolute [&>div:first-child]:inset-x-0 [&>div:first-child]:top-0 [&>div:first-child]:z-20 [&>div:first-child]:mb-0 [&>div:first-child]:justify-start [&>div:first-child]:bg-transparent [&>div:first-child]:px-3 [&>div:first-child]:pt-2' bodyClassName='flex h-full flex-col overflow-hidden p-0 w-full max-h-none' headClassName='hidden' displayType='default' closeButtonClassName='absolute left-3 top-3 !text-text-white' data-sentry-element="Modal" data-sentry-component="WomanDetailModal" data-sentry-source-file="detail-modal.tsx">
            <div className='flex h-full flex-col'>
                <div className='flex-1'>
                    <LazyImage key={details.image_url} src={details.image_url} alt={details.name} className='h-full w-full object-contain object-top' data-sentry-element="LazyImage" data-sentry-source-file="detail-modal.tsx" />
                </div>

                <div key={details.name} className='z-10 -mt-32 flex h-full flex-1 flex-col overflow-hidden rounded-t-2xl bg-white/70 p-3 backdrop-blur-md'>
                    <div className={cn('flex min-h-0 flex-1 flex-col overflow-hidden pb-2', direction === 'prev' ? 'detail-slide-prev' : 'detail-slide-next')}>
                        <div className='flex shrink-0 items-center justify-between'>
                            <h2 className='font-bold'>{details.name}</h2>
                            <span className='rounded bg-white px-2 py-1 text-xs'>{details.category}</span>
                        </div>
                        <span className='mt-2 shrink-0 text-body-14'>{details.role}</span>
                        <span className='mt-2 shrink-0 text-caption-12'>
                            {details.birth_date}
                            {' - '}
                            {details.death_date}
                        </span>

                        <p className='hide-scrollbar mt-4 min-h-0 flex-1 overflow-auto text-body-14'>
                            {details.description}
                        </p>
                    </div>

                    <div className='flex shrink-0 justify-end gap-3'>
                        <button type='button' onClick={() => handleNavigateDetailsModal('prev')} className='flex h-10 w-10 items-center justify-center rounded-full border border-border-gray-light'>
                            <IconArrowSquareRight className='h-6 w-6' data-sentry-element="IconArrowSquareRight" data-sentry-source-file="detail-modal.tsx" />
                        </button>

                        <button type='button' onClick={() => handleNavigateDetailsModal('next')} className='flex h-10 w-10 items-center justify-center rounded-full border border-border-gray-light'>
                            <IconArrowSquareLeft className='h-6 w-6' data-sentry-element="IconArrowSquareLeft" data-sentry-source-file="detail-modal.tsx" />
                        </button>
                    </div>
                </div>
            </div>
        </Modal>;
};
export default WomanDetailModal;